import { render, staticRenderFns } from "./TimelineSurgery.vue?vue&type=template&id=c81deb42&"
import script from "./TimelineSurgery.vue?vue&type=script&lang=js&"
export * from "./TimelineSurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports